import { parseDynamicData } from '$shared/helpers/utils';

export class NpiBasicModel {
  private readonly data: ObjectType<any>;

  constructor(data: ObjectType<any>) {
    if (!data) return;
    this.data = data;
  }

  private get gender(): string {
    switch (this.data?.gender) {
      case 'M':
        return 'Male';
      case 'F':
        return 'Female';
      default:
        return '';
    }
  }

  public get status(): string {
    return this.data?.status || '';
  }

  public getName(): string {
    const defaultFullName = [this.data.firstName, this.data.middleName, this.data.lastName];
    let name = defaultFullName.filter(Boolean).join(' ').trim();

    if (!name) {
      const fullName = [
        this.data.authorizedOfficialFirstName,
        this.data.authorizedOfficialMiddleName,
        this.data.authorizedOfficialLastName
      ];
      name = fullName.filter(Boolean).join(' ').trim();
    }

    return name;
  }

  public toList(): IDataList {
    const tempResult = {};

    Object.entries(this.data).forEach(([key, val]) => {
      if (key === 'gender') {
        tempResult[key] = this.gender;
        return;
      }
      tempResult[key] = parseDynamicData(val);
    });
    return tempResult;
  }
}
